import type { RouteRecordRaw } from 'vue-router';
import {
  CREDENTIAL_API_ROUTE_NAMES,
  CREDENTIAL_API_ROUTE_PATHS,
} from '@/shared/common/constants/credentialApiRoutes.constant';
import { credentialApiIntroGuard } from './credentialApi.guard';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const CredentialApiIntroPage = () =>
  import('@/modules/credentialApi/pages/CredentialApiIntro/index.vue');
const CredentialApiMainPage = () =>
  import('@/modules/credentialApi/pages/CredentialApiMain/index.vue');

export const credentialApiRoutes: Array<RouteRecordRaw> = [
  {
    path: '/api-credentials',
    component: MainLayout,
    meta: {
      flag: 'feature_credential_api',
    },
    beforeEnter: credentialApiIntroGuard,
    children: [
      {
        path: '',
        name: 'api-credentials',
        component: CredentialApiMainPage,
        meta: {
          requiresAuth: true,
          title: 'Credenciales API',
        },
      },
      {
        path: 'intro',
        name: 'api-credentials-intro',
        component: CredentialApiIntroPage,
        meta: {
          requiresAuth: true,
          title: 'Credenciales API',
          activeMenu: CREDENTIAL_API_ROUTE_PATHS[CREDENTIAL_API_ROUTE_NAMES.MAIN],
        },
      },
    ],
  },
];
